import styled from 'styled-components';

export default styled.div`
  align-items: center;
  justify-content: flex-end;
  display: flex;
  padding: 1rem;
`;
